import { render, staticRenderFns } from "./SunsetPointsInput.vue?vue&type=template&id=2c32fded&scoped=true"
import script from "./SunsetPointsInput.vue?vue&type=script&lang=js"
export * from "./SunsetPointsInput.vue?vue&type=script&lang=js"
import style0 from "./SunsetPointsInput.vue?vue&type=style&index=0&id=2c32fded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32fded",
  null
  
)

export default component.exports